import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'tad-share-institution-dialog',
  templateUrl: './share-institution-dialog.component.html',
  styleUrls: ['./share-institution-dialog.component.scss']
})
export class ShareInstitutionDialogComponent {
  public email = new FormControl(null, Validators.required);

  constructor(private dialogRef: MatDialogRef<ShareInstitutionDialogComponent>) {}
  public download(): void {
    this.dialogRef.close({action: 'download'});
  }
  public send(): void {
    if (this.email.invalid) {
      return
    }

    this.dialogRef.close({action: 'send', email: this.email.value});
  }
}
